export default "__VITE_ASSET__ChWJYqyt__"